<div class="position-relative">
    <button #myButton class="common_button d-flex align-items-center justify-content-center"
        type="button" (click)="addEditComment(formModel)" id="comment" [ngClass]="ngClass" [class]="buttonClass">
        <span>{{formModel?.invoiceModel?.id && isCommentAvailable(formModel?.invoiceModel?.comment)?'View Comment':'Add Comment'}}</span>
    </button>
    <ng-container *ngIf="badgeCount?.length>0">
        <span class="badge badge-secondary">{{badgeCount?.length}}</span>
    </ng-container>
</div>